import { makeRequest } from '@/libs/RequestModule'
import store from '@/store/index.js'

const updateSonsAfterRecharge = async function () {
    const response = (await makeRequest('getfilhos'))?.data
    store.dispatch('setDependents', response)
}

export { updateSonsAfterRecharge }
